import styled from "styled-components";
import { HeaderBox, HeaderTitle, ViewContainer } from "./SignUpPage.style";

function SignUpPage() {
  return (
    <ViewContainer>
      <HeaderBox>
        <HeaderTitle>회원가입</HeaderTitle>
      </HeaderBox>
    </ViewContainer>
  );
}

export default SignUpPage;
